import React from "react";
import PropTypes from "prop-types";
import { Box, Typography } from "@mui/material";

import UIIcon from "../UIIcon";
import { clx } from "../../../utils/Helpers";
import "./UIChangeSummary.scss";

const toneClassNames = {
  primary: "ui-change-summary--primary",
  warning: "ui-change-summary--warning",
  error: "ui-change-summary--error",
  success: "ui-change-summary--success",
  neutral: "ui-change-summary--neutral",
  outline: "ui-change-summary--outline",
};

const separatorIcons = {
  chevron: { name: "chevronRightSolid", width: 5, height: 10 },
  swap: { name: "swap", width: 16, height: 16 },
};

const UIChangeSummary = ({
  label,
  items,
  description,
  tone,
  separator,
  className,
}) => {
  const separatorIcon = separatorIcons[separator];

  return (
    <Box className={clx("ui-change-summary", toneClassNames[tone], className)}>
      <Box className="ui-change-summary__items">
        {label && (
          <Typography component="span" className="ui-change-summary__label">
            {label}
          </Typography>
        )}
        {items.map((item, index) => (
          <React.Fragment key={`${String(item)}-${index}`}>
            {index > 0 && separator !== "none" && (
              <span className="ui-change-summary__separator">
                {separatorIcon ? (
                  <UIIcon
                    name={separatorIcon.name}
                    width={separatorIcon.width}
                    height={separatorIcon.height}
                    color="currentColor"
                    decorative
                  />
                ) : (
                  "•"
                )}
              </span>
            )}
            <Typography component="span" className="ui-change-summary__item">
              {item}
            </Typography>
          </React.Fragment>
        ))}
      </Box>
      {description && (
        <Typography className="ui-change-summary__description">
          {description}
        </Typography>
      )}
    </Box>
  );
};

UIChangeSummary.propTypes = {
  /** Leading caption for the row, e.g. "Replacing". */
  label: PropTypes.node,
  items: PropTypes.arrayOf(PropTypes.node),
  description: PropTypes.node,
  tone: PropTypes.oneOf([
    "primary",
    "warning",
    "error",
    "success",
    "neutral",
    "outline",
  ]),
  separator: PropTypes.oneOf(["chevron", "swap", "dot", "none"]),
  className: PropTypes.string,
};

UIChangeSummary.defaultProps = {
  label: null,
  items: [],
  description: null,
  tone: "primary",
  separator: "chevron",
  className: "",
};

export default UIChangeSummary;
